var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "team-Statistics" }, [
    _c("h4", [_vm._v(" " + _vm._s(_vm.$t("showFraction.TDTJ")) + " ")]),
    _c("div", { staticClass: "content-title" }, [
      _c("div", [
        _vm._m(0),
        _c("div", { staticClass: "text-box" }, [
          _c("div", { staticClass: "text-top" }, [
            _c("span", { staticClass: "font-title" }, [
              _vm._v(
                _vm._s(
                  _vm.stData.completeDto
                    ? _vm.stData.completeDto.numerator
                    : "0"
                )
              ),
            ]),
            _c("span", { staticClass: "total-font" }, [
              _vm._v(
                "/" +
                  _vm._s(
                    _vm.stData.completeDto
                      ? _vm.stData.completeDto.denominator
                      : "0"
                  )
              ),
            ]),
          ]),
          _c("span", { staticClass: "font-status" }, [
            _vm._v(" " + _vm._s(_vm.$t("showFraction.WCDDW")) + " "),
          ]),
        ]),
      ]),
      _c("div", [
        _vm._m(1),
        _c("div", { staticClass: "text-box" }, [
          _c("div", { staticClass: "text-top" }, [
            _c("span", { staticClass: "font-title" }, [
              _vm._v(
                _vm._s(
                  _vm.stData.absentDto ? _vm.stData.absentDto.numerator : "0"
                )
              ),
            ]),
            _c("span", { staticClass: "total-font" }, [
              _vm._v(
                "/" +
                  _vm._s(
                    _vm.stData.absentDto
                      ? _vm.stData.absentDto.denominator
                      : "0"
                  )
              ),
            ]),
          ]),
          _c("span", { staticClass: "font-status" }, [
            _vm._v(" " + _vm._s(_vm.$t("showFraction.QQDDW")) + " "),
          ]),
        ]),
      ]),
      _c("div", [
        _vm._m(2),
        _c("div", { staticClass: "text-box" }, [
          _c("div", { staticClass: "text-top" }, [
            _c("span", { staticClass: "font-title" }, [
              _vm._v(_vm._s(_vm._f("toFixed2")(_vm.stData.maxScore))),
            ]),
          ]),
          _c("span", { staticClass: "font-status" }, [
            _vm._v(" " + _vm._s(_vm.$t("showFraction.ZGF")) + " "),
          ]),
        ]),
      ]),
      _c("div", [
        _vm._m(3),
        _c("div", { staticClass: "text-box" }, [
          _c("div", { staticClass: "text-top" }, [
            _c("span", { staticClass: "font-title" }, [
              _vm._v(_vm._s(_vm._f("toFixed2")(_vm.stData.avgMaxScore))),
            ]),
          ]),
          _c("span", { staticClass: "font-status" }, [
            _vm._v(" " + _vm._s(_vm.$t("showFraction.PJZGF")) + " "),
          ]),
        ]),
      ]),
      _c("div", [
        _vm._m(4),
        _c("div", { staticClass: "text-box" }, [
          _c("div", { staticClass: "text-top" }, [
            _c("span", { staticClass: "font-title" }, [
              _vm._v(_vm._s(_vm._f("toFixed2")(_vm.stData.goodRate))),
            ]),
            _c("span", [_vm._v("%")]),
          ]),
          _c("span", { staticClass: "font-status" }, [
            _vm._v(" " + _vm._s(_vm.$t("showFraction.YXL")) + " "),
          ]),
        ]),
      ]),
      _c("div", [
        _vm._m(5),
        _c("div", { staticClass: "text-box" }, [
          _c("div", { staticClass: "text-top" }, [
            _c("span", { staticClass: "font-title" }, [
              _vm._v(_vm._s(_vm._f("toFixed2")(_vm.stData.passRate))),
            ]),
            _c("span", [_vm._v("%")]),
          ]),
          _c("span", { staticClass: "font-status" }, [
            _vm._v(" " + _vm._s(_vm.$t("showFraction.JGL")) + " "),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img-box" }, [
      _c("img", { attrs: { src: require("@/assets/image/1.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img-box" }, [
      _c("img", { attrs: { src: require("@/assets/image/2.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img-box" }, [
      _c("img", { attrs: { src: require("@/assets/image/3.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img-box" }, [
      _c("img", { attrs: { src: require("@/assets/image/4.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img-box" }, [
      _c("img", { attrs: { src: require("@/assets/image/5.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img-box" }, [
      _c("img", { attrs: { src: require("@/assets/image/6.png") } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }